import PropTypes from 'prop-types';

const HeaderImage = ({ image }) => (
  <div className="relative mb-4 overflow-hidden rounded-lg">
    <img 
      src={image} 
      alt="Campaign header" 
      className="object-cover w-full h-full"
    />
  </div>
);

HeaderImage.propTypes = {
  image: PropTypes.string,
};

export default HeaderImage;